export default{
    empleados: [],
    empleadoSelec: null,
    MessageContrasena: ""
   
}